import Stack, { type StackProps } from '@mui/material/Stack';
import { pxToRem } from '../../../utils/pxToRem';

export type SectionInnerProps = StackProps;

export function SectionInner({ sx, ...rest }: SectionInnerProps) {
  return (
    <Stack
      {...rest}
      sx={[
        {
          width: '100%',
          maxWidth: '100%',
          paddingInline: { mobile: pxToRem(16), laptop: pxToRem(150) },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
}
